module.exports = "/_next/static/images/CompanyHistory-2x-b3ea37b18ed106f069697fc5fec2db2b.jpg.webp";